module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main